import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-650c100d")

_pushScopeId("data-v-650c100d")
const _hoisted_1 = { class: "work-record-application" }
const _hoisted_2 = { class: "mt-2 font-bold text-2xl" }
const _hoisted_3 = { class: "work-record-table" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "font-bold pt-3 pb-1 border-b border-blue-600 mb-4" }
const _hoisted_6 = { class: "text-base flex items-center" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = { class: "font-bold pt-3 pb-1 border-b border-blue-600 mb-4" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "font-bold text-sm" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "font-bold text-sm" }
const _hoisted_16 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_ReasonUpdateStatusApplication = _resolveComponent("ReasonUpdateStatusApplication")
  const _component_ReasonCreateApplication = _resolveComponent("ReasonCreateApplication")
  const _component_ApplicationApproveFlowDetail = _resolveComponent("ApplicationApproveFlowDetail")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_BackPreviousPage, { onClick: _ctx.returnScreen }, null, 8, ["onClick"]),
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('waitingAllowanceDeleteApplication')), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('overtimeRegister.targetDate')), 1),
          _createVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.targetDate) + " ", 1),
            _createVNode("div", _hoisted_7, "(" + _toDisplayString(_ctx.t('month')) + ")", 1)
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t('waitingAllowanceTargetBeDelete')), 1),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('timeCardNew.numberOfWaits')), 1),
            _createVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.dataRecordApplicationDelete.wait_numbers) + " ", 1),
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.t('times')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('attendanceOrganization')), 1),
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.dataRecordApplicationDelete.checkin_unit_name), 1)
          ])
        ])
      ]),
      _createVNode(_component_ReasonUpdateStatusApplication, { status: _ctx.statusApplication }, null, 8, ["status"])
    ]),
    _createVNode(_component_ReasonCreateApplication, {
      "is-valid": !_ctx.isDisableSubmit,
      validated: _ctx.validated,
      errors: _ctx.errors.application_reason,
      "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors.application_reason = $event)),
      "error-server": _ctx.errorsServer.application_reason,
      modelValue: _ctx.dataRecordApplicationDelete.application_reason,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataRecordApplicationDelete.application_reason = $event)),
      onHandleCreateApplication: _ctx.createAllowanceApplicationDelete,
      onHandleCancel: _ctx.returnScreen
    }, null, 8, ["is-valid", "validated", "errors", "error-server", "modelValue", "onHandleCreateApplication", "onHandleCancel"]),
    _createVNode(_component_ApplicationApproveFlowDetail, {
      status: _ctx.statusApplication,
      createdAt: _ctx.createdAt
    }, null, 8, ["status", "createdAt"])
  ], 64))
})